// project imports
import MenuList from './MenuList';

// ==============================|| SIDEBAR ||============================== //

const Sidebar = () => {
    const version = process.env.REACT_APP_VERSION;

    return (
        <aside className="gd-sidebar" aria-label="Main navigation">
            <MenuList />
            <div className="gd-sidebar__version">
                <span>{version}</span>
            </div>
        </aside>
    );
};

export default Sidebar;
